import React, {
  useState,
  forwardRef,
  useCallback,
  useImperativeHandle,
} from 'react';
import { Icon, IconButton, Modal } from '@material-ui/core';
import {
  useStyles,
  TitleModal,
  CloseModal,
  ContainerModal,
  ContainerTopModal,
} from './styles';
import GroupForm from './GroupForm';

export const ModalForm = forwardRef(({ handleGetGroups }, ref) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  const [initialValues, setInitialValues] = useState({
    name: null,
    status: true,
    type: 1,
    permission: null,
  });

  const openModalGroups = useCallback((item) => {
    setInitialValues(item);
    setOpen(true);
  }, []);

  useImperativeHandle(
    ref,
    () => {
      return {
        openModalGroups,
      };
    },
    []
  );

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ContainerModal className={classes.paper}>
        <ContainerTopModal>
          <TitleModal>
            {initialValues.name ? 'Editar Grupo' : 'Cadastrar Grupo'}
          </TitleModal>
          <CloseModal>
            <IconButton
              onClick={() => setOpen(false)}
              className={classes.closeButton}
            >
              <Icon>close</Icon>
            </IconButton>
          </CloseModal>
        </ContainerTopModal>
        <GroupForm
          initialValues={initialValues}
          handleCloseModal={() => setOpen(false)}
          handleGetGroups={handleGetGroups}
        />
      </ContainerModal>
    </Modal>
  );
});
